import React from "react";
import { PulseLoader } from "./pulse_loader";
import { stylex } from "./stylex";

export function LoadingOverlay() {
  return (
    <div style={styles("root")}>
      <PulseLoader />
    </div>
  );
}

const styles = stylex.create({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: 80,
    boxSizing: "border-box",
    position: "fixed",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
  },
});
